import { useMemo, useState } from 'react'

import { Images } from '../../../assets'

import { MapStage, MapStageSvg, DummyBadge } from './dashboard-jetty.styled'
import { _getVesselImage, _renderTooltips } from './dashboard-jetty.helper'
import {
  MAP_WIDTH,
  MAP_HEIGHT,
  BERTH_COUNT,
  FUEL_BUNKER_KEY,
  resolveSlotKey,
  getVesselGeometry,
  RenderTOJSlot,
} from './dashboard-jetty-map.helper'
import TOJModal from './dashboard-toj-modal.container'

// Jetties are matched to map slots by jetty name ("Berth 1".."Berth 9",
// "Fuel Bunker"). If none of the names is recognised (e.g. legacy names), fall
// back to the API order for the berths so the map still renders.
const _mapJettiesToSlots = (dataJetty) => {
  const list = dataJetty || []
  const named = list.map((dt) => resolveSlotKey(dt.Jetty_Name))
  const useIndexFallback = list.length > 0 && named.every((key) => key === null)

  const slots = []
  list.forEach((dt, i) => {
    const key = useIndexFallback ? (i < BERTH_COUNT ? i + 1 : null) : named[i]
    if (key === null) {
      console.warn(`[Jetty Maps] Jetty "${dt.Jetty_Name}" is not mapped to any slot`)
      return
    }
    const detail = dt.Detail ? [...dt.Detail].sort((a, b) => a.position - b.position) : []
    if (detail.length === 0) return
    slots.push({ key, detail: detail[0] })
  })
  return slots
}

const VesselMorowali = (props) => {
  const [showModalTOJ, setShowModalTOJ] = useState(false)
  const [selectedItem, setSelectedItem] = useState()

  const toggleModalTOJ = () => setShowModalTOJ((prev) => !prev)

  const hadleClickItem = (item) => {
    setSelectedItem(item)
    toggleModalTOJ()
  }

  const slots = useMemo(
    () => _mapJettiesToSlots(props.dataJetty),
    [props.dataJetty]
  )

  return (
    <MapStage>
      {showModalTOJ && (
        <TOJModal data={selectedItem} open={showModalTOJ} handleClose={toggleModalTOJ} />
      )}
      {props.isDummy && <DummyBadge>DUMMY DATA</DummyBadge>}
      <MapStageSvg viewBox={`0 0 ${MAP_WIDTH} ${MAP_HEIGHT}`}>
        {slots.map(({ key, detail }) => {
          const geometry = getVesselGeometry(key, detail.Vessel_Size)
          const src = Images[`${_getVesselImage(detail.Vessel_Size)}`]
          if (!src) return null
          const id = key === FUEL_BUNKER_KEY ? 'fuel-bunker' : key
          return (
            <image
              key={id}
              id={`dashboard-maps-div-jetty-${id}`}
              href={src}
              x={geometry.x - geometry.length / 2}
              y={geometry.y - geometry.breadth / 2}
              width={geometry.length}
              height={geometry.breadth}
              preserveAspectRatio='none'
              transform={geometry.horizontal ? undefined : `rotate(90 ${geometry.x} ${geometry.y})`}
              style={{ pointerEvents: 'auto' }}
              data-tip
              data-for={`jetty-${id}`}
            />
          )
        })}
      </MapStageSvg>
      {slots.map(({ key, detail }) => (
        <div key={key}>
          <RenderTOJSlot
            data={detail}
            handleClick={hadleClickItem}
            geometry={getVesselGeometry(key, detail.Vessel_Size)}
          />
          {_renderTooltips(detail, `jetty-${key === FUEL_BUNKER_KEY ? 'fuel-bunker' : key}`, 0)}
        </div>
      ))}
    </MapStage>
  )
}

export default VesselMorowali
